<template>
    <svg version="1.1" id="Layer_1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="11px" height="20px" viewBox="0 0 11 20"
         style="enable-background:new 0 0 11 20;"
         xml:space="preserve">
															<path class="st0" fill="#FFFFFF"
                                                                  d="M7.997,3.545h2.313V0H7.997C4.971,0,3.083,1.771,3.083,5.045v2.467H0v3.545h3.083V20H6.63v-8.942h3.044 l0.482-3.545H6.63V4.891C6.63,4.18,7.043,3.545,7.997,3.545"/>
														</svg>
</template>

<script>
    export default {}
</script>